<template>
	<div class="login-page flex">
		<div class="box grow scrollable align-vertical side-box box-left">
			<div class="align-vertical-middle wrapper text-center">
				<img v-if="interfaceConfigurationActive" class="hidden-sm-and-down" :src="logo" style="max-width:340px;" alt="logo-left"/>
				<img v-else class="h-big image-logo hidden-sm-and-down" :src="logo" alt="logo-left"/>
				<h1 v-if="!interfaceConfigurationActive" class="h-big">Portaus</h1>
				<p class="p-50 hidden-sm-and-down"><span v-html="slogan"></span></p>
			</div>
			<h1 v-if="interfaceConfigurationActive" style="position:absolute;color:#fff;bottom:0px;font-size:15px;margin-left:20px;">Propulsé par Portaus</h1>
		</div>
		<div class="box grow scrollable align-vertical side-box box-right">
			<div class="align-vertical-middle wrapper">

				<form class="form-box animated fadeInLeft" v-if="!forgotPassword" ref="auth">
					<h2>Se connecter au portail</h2>
					<p class="mb-40">Accéder au Tableau de bord</p>

					<float-label class="styled">
							<input type="email" v-bind:placeholder="$t('login.Courriel')" v-model="form.username" v-on:keyup.enter="login">
					</float-label>
					<float-label class="styled">
						<input type="password" v-bind:placeholder="$t('login.Mot-de-passe')" v-model="form.password" v-on:keyup.enter="login">
					</float-label>
					<div class="flex">
						<!-- <div class="box grow"><el-checkbox>{{ $t("login.Se-souvenir-de-moi") }}</el-checkbox></div> -->
						<div class="box grow text-right"><el-link @click="forgotPassword=true">{{ $t("login.Mot-de-passe-oublie") }}</el-link></div>
					</div>

					<div class="flex text-center center pt-30 pb-10">
						<el-button plain size="small" @click="login" class="login-btn pulse animated themed">
							{{ $t("login.Se-connecter") }}
						</el-button>
					</div>

				</form>
				<div v-if="emailSent && forgotPassword"  class="form-box" style="text-align:center;">
					<i class="el-icon-circle-check" style="font-size:100px;"></i>
					<p>Un courriel avec un lien sécurisé pour modifier votre mot de passe a été envoyé à votre boîte courriel.</p>
					<el-link @click="returnToLogin" :underline="false"><i class="mdi mdi-arrow-left-bold-box-outline"><span slot="title">Retour</span></i></el-link>
				</div>
				<form v-if="forgotPassword && !emailSent" class="form-box animated fadeInRight" ref="recoverPassword" @submit.prevent="recoverPassword" >
					<h2>Mot de passe oublié</h2>
					<p style="margin-bottom:30px;">Remplissez le champ ci-dessous pour recevoir un courriel contenant les instructions pour réinitialiser votre mot de passe.</p>
					<float-label class="styled">
						<input type="email" v-bind:placeholder="$t('login.Courriel')" v-model="email" v-on:keyup.enter="recoverPassword">
					</float-label>

					<div class="flex text-center center pt-20 pb-10">
						<el-button plain size="small" @click="recoverPassword" class="send-btn tada animated">
							{{$t('login.send_reset_password')}}
						</el-button>
					</div>
					<el-link @click="returnToLogin" :underline="false"><i class="mdi mdi-arrow-left-bold-box-outline"><span slot="title">Retour</span></i></el-link>
				</form>
			</div>

		</div>

	</div>
</template>

<script>

import {AUTH_REQUEST,AUTH_RECOVER_PASSWORD} from '../../../store/actions/auth'
import PortausUtils from '@/utils/portaus-utils'
export default {
	name: 'Login',
	data() {
		return {
			form : {
				username: '',
				password: ''
			},
			email : null,
			forgotPassword : false,
			emailSent : false

		}
	},
	methods: {
		returnToLogin(){
			this.forgotPassword=false;
			this.emailSent=false;
			this.email= null;
			this.form.username='';
			this.form.password='';
		},
		login(e) {
			const {username, password} = this.form;
		   this.$store.dispatch(AUTH_REQUEST, {username, password}).then((resp) => {
         PortausUtils.changePortausContext(resp.data.portausContextToken, resp.data.portausCompany.id, this);
         this.$ability.update(resp.data.rules);
				 if(localStorage.profileId==null && this.$store.getters.customerProfiles.length>1){
		 			this.$emit("changeAccount");
		 		}else{
					this.$router.push('dashboard');
				}

		   }).catch(err=>{
				 console.log(err);
				 this.$message({
						 showClose: true,
						 message: err.response.data.message,
						 type: 'error'});
						 return null;
			 })
			 e.preventDefault();
		},
		recoverPassword(){
			this.$store.dispatch(AUTH_RECOVER_PASSWORD, this.email)
				.then(()=>{
					this.emailSent=true;
				}).catch(err=>{
					this.emailSent=true;
				})
		},
	},
	computed : {
		interfaceConfigurationActive(){
			// console.log((localStorage.INTERFACE_CONFIGURATION!=null && JSON.parse(localStorage.INTERFACE_CONFIGURATION).active));
			return (localStorage.INTERFACE_CONFIGURATION!=null && JSON.parse(localStorage.INTERFACE_CONFIGURATION).active);
		},
		ifSessionExpired(){
			return this.$route.query.session=="expired";
		},
		slogan(){
			if(this.interfaceConfigurationActive){
				return JSON.parse(localStorage.INTERFACE_CONFIGURATION).slogan;
			}else{
				return `"Le mot <strong>portaus</strong> est un dérivé du mot porte. Le sens ancien était « grand panneau de bois servant de porte », puis dès le xviie siècle, on note les sens actuels restreints aux édifices religieux de « façade d'une église où est la porte principale » et « grande porte d'une église ou d'un temple ». De manière contemporaine, il est employé pour désigner <strong>toute porte plus monumentale qu'une porte ordinaire</strong>."`;
			}
		},
		logo(){
			// return require("@/assets/images/logo.svg");
			if(this.interfaceConfigurationActive){
				return require('@/assets/images/'+JSON.parse(localStorage.INTERFACE_CONFIGURATION).logo);
			}else{
				return require("@/assets/images/logo.svg");
			}
		}
	},
	mounted(){
		if(this.ifSessionExpired){
			this.$message({
					showClose: true,
					message: "La session est expirée. Veuillez vous authentifier de nouveau.",
					duration:5000,
					type: 'error'});
		}
	}
}
</script>

<style lang="scss">
@import '../../../assets/scss/_variables';

.login-page {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 0 !important;

	.side-box {
		.wrapper {
			width: 100%;
			box-sizing: border-box;
			padding: 20px;
		}
	}

	.box-left {
		background-image: url('../../../assets/images/login_cover.jpg');
		background-size: cover;
		background-position: 50% 50%;

		.wrapper {
			.image-logo {
				width: 90%;
				max-width: 100px;
				margin-top: 20px;
			}

		}
	}
	.box-right {
		background: white;
		color: var(--background-color);
	}

	.form-box {
		width: 100%;
		max-width: 340px;
		padding: 30px;
		box-sizing: border-box;
		margin: 20px auto;
		//background: transparent;

		a {
			font-size: 14px;
			color: var(--color-accent);
			text-decoration: none;
			font-weight: 500;
		}

		.image-logo {
			width: 80px;
			margin: 0px auto;
			margin-bottom: 70px;
			display: block;
		}

		.login-btn {
			background: rgba(var(--color-accent-rgb), .2);
			color: var( --text-color);
			border-color: var(--text-color);
			border-width: 2px;
			font-weight: bold;
			border-radius: 0;

			&:hover {
				background: rgba(var(--color-accent-rgb), 1);
				border-color: var(--text-color);
				color: var( --text-color);
			}
		}
	}
}

@media (max-width: 1200px) {
.login-page {
	.box-left {
		.wrapper {
			.h-big {
				font-size: 50px;
			}
		}
	}
}
}
@media (max-width: 900px) {
.login-page {
	.box-left {
		.wrapper {
			.h-big {
				font-size: 30px;
			}
		}
	}
}
}
@media (max-width: 768px) {
.login-page {
	display: block;
	overflow: auto;

	.side-box {
		display: block;
	}
}
}
</style>
